export default __webpack_public_path__ + "static/media/hotel-resort-bg-04.10e4c487.jpg";